import { IGetControleCentroCustoByIdUseCase } from "../../../presentation/useCases/read/get_controle_centro_custo_by_id_use_case";
import { ControleCentroCustoDetalhe } from "../../models/controle_centro_custo_detalhe";
import { IControlePatrimonioRepository } from "../../repositories/ControledePatrimonio";

/**
 * GetControleCentroCustoByIdUseCase
 */

export class GetControleCentroCustoByIdUseCase implements IGetControleCentroCustoByIdUseCase {
  constructor(private readonly repository: IControlePatrimonioRepository) { }

  async getControleCentroCustoById(
    idControleCentroCusto: number | undefined,
  ): Promise<ControleCentroCustoDetalhe> {
    if (idControleCentroCusto === undefined) throw new Error('Falha ao obter id do controle de centro de custo!');
    const results = await this.repository.getControleCentroCustoById(idControleCentroCusto);
    if (results === null) throw new Error('Falha ao buscar dados do controle de centro de custo!');
    return results;
  }
}
